import { type TranslationSchema } from '~/locales/resources'
import {
  type FiveSegment,
  type FiveSegmentIndicator,
  fiveSegmentIndicators,
  fiveSegments,
} from '~/utils'

export const fiveSegmentIndicatorHelpI18nMap: Record<
  FiveSegmentIndicator,
  keyof TranslationSchema
> = {
  rateRecognition:
    'aware_noncustomersdefected_customersregular_customersloyal_customers',
  rateCurrentUser: 'regular_customersloyal_customers',
  rateLoyal: 'loyal_customers',
  rateCv:
    'defected_customersregular_customersloyal_customersaware_noncustomersdefected_customersregular_customersloyal_customers',
  ratioLoyalToCurrentUser: 'loyal_customersregular_customersloyal_customers',
}

export type FiveSegmentColumnKey =
  | FiveSegment
  | FiveSegmentIndicator
  | 'brandName'
  | 'brandNumber'
  | 'indicatorPad'

export const fiveSegmentSortColumnKeys = [
  ...fiveSegments,
  ...fiveSegmentIndicators,
] as const satisfies readonly FiveSegmentColumnKey[]
export type FiveSegmentSortColumnKey =
  (typeof fiveSegmentSortColumnKeys)[number]

export const fiveSegmentDisplayColumnKeys = [
  ...fiveSegments,
  ...fiveSegmentIndicators,
] as const satisfies readonly FiveSegmentColumnKey[]
export type FiveSegmentDisplayColumnKey =
  (typeof fiveSegmentDisplayColumnKeys)[number]
